var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('McTable',_vm._b({},'McTable',_vm.propsData,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }